import { defineMessages } from 'react-intl'

export const teamAddUserModalMessages = defineMessages({
  title: {
    id: 'teamAddUserModal.title',
    description: 'Add User modal title on Team page',
    defaultMessage: 'Add User to {selectedDomainName}',
  },
  emailField: {
    id: 'teamAddUserModal.emailField',
    description: 'Email field label for Add User modal on Team page',
    defaultMessage: 'Email',
  },
  firstNameField: {
    id: 'teamAddUserModal.firstNameField',
    description: 'First Name field label for Add User modal on Team page',
    defaultMessage: 'First Name',
  },
  lastNameField: {
    id: 'teamAddUserModal.lastNameField',
    description: 'Last Name field label for Add User modal on Team page',
    defaultMessage: 'Last Name',
  },
  permissionsBlockTitle: {
    id: 'teamAddUserModal.permissionsBlockTitle',
    description: 'Permissions block title for Add User modal on Team page',
    defaultMessage: 'Savant Central Management Permissions',
  },
  adminPermissionLabel: {
    id: 'teamAddUserModal.adminPermissionLabel',
    description: 'Admin permission label for Add User modal on Team page',
    defaultMessage: 'Admin',
  },

  configPermissionLabel: {
    id: 'teamAddUserModal.configPermissionLabel',
    description: 'Config permission label for Add User modal on Team page',
    defaultMessage: 'Config',
  },
  subscriptionManagementPermissionLabel: {
    id: 'teamAddUserModal.subscriptionManagementPermissionLabel',
    description:
      'Subscription Management permission label for Add User modal on Team page',
    defaultMessage: 'Subscription Management',
  },
  sendInviteButton: {
    id: 'teamAddUserModal.sendInviteButton',
    description: 'Send Invite button label for Add User modal on Team page',
    defaultMessage: 'Send Invite',
  },
  addUserButton: {
    id: 'teamAddUserModal.addUserButton',
    description: 'Add user button label for Add User modal on Team page',
    defaultMessage: 'Add',
  },
  newUserInfoMessage: {
    id: 'teamAddUserModal.newUserInfoMessage',
    description: 'New User info message for Add User modal on Team page',
    defaultMessage:
      'No Savant Account found, user will receive invite to create account.',
  },
  userFoundInfoMessage: {
    id: 'teamAddUserModal.userFoundInfoMessage',
    description: 'User Found info message for Add User modal on Team page',
    defaultMessage: 'User found',
  },
  userAlreadyInTeamInfoMessage: {
    id: 'teamAddUserModal.userAlreadyInTeamInfoMessage',
    description:
      'User is already in the team info message for Add User modal on Team page',
    defaultMessage: 'This user is already on the team',
  },
})
